module.exports = __webpack_public_path__ + "img/组 147.9462ae51.png";